export const dashboardMeta = {
  title: 'ICT Service',
  slot: 'index-case-testing-esm-slot',
  path: 'index-case-testing-service',
};
